import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OwnershipListComponent } from './ownership-list/ownership-list.component';
import { OwnershipCreateComponent } from './ownership-create/ownership-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: OwnershipListComponent,
        data: {
          title: "Ownership List",
          breadcrumb: "Ownership List"
        }
      },
      {
        path: 'create',
        component: OwnershipCreateComponent,
        data: {
          title: "Create Ownership",
          breadcrumb: "Create Ownership"
        }
      },
      {
        path: 'edit/:id',
        component: OwnershipCreateComponent,
        data: {
          title: "Edit Ownership",
          breadcrumb: "Edit Ownership"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class OwnershipRoutingModule { }
